import {
  InvoicingDefaultLateMaxDaysTypeEnum,
  UpdateInvoicePresetsInput,
} from '__generated__/GQL';

import { InvoicePresetsFormSchema } from '../invoicePresetsForm.schema';

const formatUpdateMutationInput = ({
  displayTradeName,
  issuerEmail,
  issuerEmailEnabled,
  lateMaxDaysOther,
  lateMaxDaysType,
  legalMentions,
  legalMentionsEnabled,
  paymentLateFee,
  quoteValidityDays,
  quoteValidityDaysEnabled,
}: InvoicePresetsFormSchema): Omit<
  UpdateInvoicePresetsInput,
  'companyProfileId'
> => ({
  invoicingDefaultCustomLegalMentions: legalMentionsEnabled
    ? legalMentions || null
    : null,
  invoicingDefaultDisplayTradeName: displayTradeName,
  invoicingDefaultIssuerEmail: issuerEmailEnabled
    ? issuerEmail?.trim() || null
    : null,
  invoicingDefaultLateFeeFloatPercentage: paymentLateFee,
  invoicingDefaultLateMaxDaysOther:
    lateMaxDaysType === InvoicingDefaultLateMaxDaysTypeEnum.Other
      ? lateMaxDaysOther
      : undefined,
  invoicingDefaultLateMaxDaysType: lateMaxDaysType,
  invoicingDefaultQuoteValidityDays: quoteValidityDaysEnabled
    ? quoteValidityDays
    : null,
});

export default formatUpdateMutationInput;
